module.exports = __webpack_public_path__ + "media/src/images/page02_zu_worksheet-b1f51f4756c66c1e53d5586dce55b0d5.png";